import { render, staticRenderFns } from "./UniqueValuesDialog.vue?vue&type=template&id=53fa4158"
import script from "./UniqueValuesDialog.vue?vue&type=script&lang=js"
export * from "./UniqueValuesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports